<template>
  <the-menu />

  <main>
    <the-slider v-if="this.$route.name !== 'home'" />
   <div :class="{'container p-2 p-lg-4': this.$route.name !== 'home'}">
     <router-view/>
   </div>
  </main>

  <the-footer />

</template>

<script>
  import TheSlider from "@/components/TheSlider";
  import TheFooter from "@/components/TheFooter";
  import TheMenu from "@/components/TheMenu";
  export default {
      components: {TheMenu, TheFooter, TheSlider},
      data: function () {
          return {
          }
      },
      mounted() {

      }
      ,
    methods:{
      scrollToPoint(id){
        let element = document.querySelector('#' + id);
        document.querySelector('body').scrollTo(element);
        document.querySelector('#' + id).scrollIntoView();
      }
    }
  }
</script>
<style>
body{
  scroll-behavior: smooth;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #2c3e50;
}
.error {
  color: lightcoral;
}

.hasError {
  border: 1.2px solid lightcoral !important;
  box-shadow: none !important;
}

.valid {
  border: 1.5px solid #42b983 !important;
  box-shadow: none !important;
}
</style>
